/**
 * Telefone de quem recebe a corrida.
 *
 * A mascara e so para quem digita: o que viaja no payload sao os digitos, e o
 * backend monta o E.164 que a Lalamove exige (App\Http\Controllers\
 * LalamoveController::telefone). Guardar o valor ja limpo evita que a mascara
 * vire regra de negocio em algum lugar.
 */

/** Digitos do telefone, sem mascara, sem DDI e no maximo 11. */
export const soDigitosTelefone = (valor) => {
    let d = String(valor ?? '').replace(/\D/g, '');

    // "5511988887777" colado de outro lugar: o 55 e DDI, nao DDD
    if (d.length > 11 && d.startsWith('55')) d = d.slice(2);

    return d.slice(0, 11);
};

/** (11) 98888-7777 para celular, (11) 3888-7777 para fixo. */
export const formatarTelefone = (valor) => {
    const d = soDigitosTelefone(valor);

    if (d.length === 0) return '';
    if (d.length <= 2) return `(${d}`;
    if (d.length <= 6) return `(${d.slice(0, 2)}) ${d.slice(2)}`;
    if (d.length <= 10) return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`;

    return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
};

/** DDD + numero: 10 digitos no fixo, 11 no celular. */
export const telefoneValido = (valor) => {
    const d = soDigitosTelefone(valor);

    return d.length === 10 || d.length === 11;
};
